import produce from 'immer';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, consultaMarcaModelo } from './types';

export const INITIAL_STATE: consultaMarcaModelo = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): consultaMarcaModelo {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONSULTA_MARCA_MODELO_REQUEST: {
				break;
			}
			case Types.CONSULTA_MARCA_MODELO_SUCCESS: {
				draft.status = 200;
				draft.data = action.payload.marcaModelo;
				break;
			}
			case Types.CONSULTA_MARCA_MODELO_FAILURE: {
				draft.status = 400;
				draft.data = INITIAL_STATE.data;
				break;
			}
			case Types.CONSULTA_MARCA_MODELO_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
